import React from 'react'
import styled from 'styled-components'
import { translate } from '~/core/translate'

const PresetContainer = styled.div`
  display: flex;
  padding: 10px;
  cursor: pointer;
  border-bottom: 1px solid;
  border-color: ${({ theme }) => theme._neo.ui02};
  gap: 10px;

  &:hover {
    background: ${({ theme }) => theme._neo.ui02};
  }
`

const PresetTitle = styled.div`
  font-weight: 600;
`

const IconWrapper = styled.div`
  padding: 10px;
`

const PresetDescription = styled.div`
  color: ${({ theme }) => theme._neo.textColor02};;
  font-size: 12px;
  line-height: 16px;
`

const MeetingPresetOption = props => {
  const { icon: Icon, label, description } = props.data

  return (
    <PresetContainer
      {...props.innerProps}
      ref={props.innerRef}
    >
      <IconWrapper><Icon size={20} /></IconWrapper>
      <div>
        <PresetTitle>{translate(label)}</PresetTitle>
        <PresetDescription>{translate(description)}</PresetDescription>
      </div>
    </PresetContainer>
  )
}

export default MeetingPresetOption
